'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActivated = exports.isAccountDisabled = exports.hasRequestSucceeded = exports.isNotRequested = exports.isRequestPending = exports.hasRequestFailed = exports.didRecentlyCreatePortal = exports.getPortalIdToAuthenticate = exports.getCreate = undefined;

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _Auth = require('./Auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCreate = exports.getCreate = function getCreate(state) {
  return state.create;
};
var getPortalIdToAuthenticate = exports.getPortalIdToAuthenticate = function getPortalIdToAuthenticate(state) {
  // Exists for new users creating a new portal
  var recentlyCreatedHubId = getCreate(state).get('createdHubId');

  // Exists for invited users joining a portal
  var stashedPortalId = _PortalIdContainer2.default.get();

  // Last ditch effort to grab portal id from existing cookies
  var cookiedPortalId = _hubspot2.default.get();
  return recentlyCreatedHubId || stashedPortalId || cookiedPortalId;
};
var didRecentlyCreatePortal = exports.didRecentlyCreatePortal = function didRecentlyCreatePortal(state) {
  return getCreate(state).get('createdHubId');
};

var getRequestState = function getRequestState(state) {
  return getCreate(state).get('requestState');
};
var getStatusCode = function getStatusCode(state) {
  return getRequestState(state).getStatusCode();
};
var hasRequestFailed = exports.hasRequestFailed = function hasRequestFailed(state) {
  return getRequestState(state).isFailed();
};
var isRequestPending = exports.isRequestPending = function isRequestPending(state) {
  return getRequestState(state).isPending();
};
var isNotRequested = exports.isNotRequested = function isNotRequested(state) {
  return getRequestState(state).isNotRequested();
};
var hasRequestSucceeded = exports.hasRequestSucceeded = function hasRequestSucceeded(state) {
  return getRequestState(state).isSuccessful();
};
var isAccountDisabled = exports.isAccountDisabled = function isAccountDisabled(state) {
  return hasRequestFailed(state) && getStatusCode(state) === 429;
};
var isActivated = exports.isActivated = function isActivated(state) {
  return !!(hasRequestSucceeded(state) && (0, _Auth.hasNewPortalAuth)(state));
};